import { all, takeLatest, call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  ENDPOINT_BUSCA_CNPJ,
  ENDPOINT_BUSCA_ENDERECO,
  ENDPOINT_FINALIZA_INDICACAO,
} from '~/config/constants';

import {
  Types,
  searchSuccess,
  searchFailure,
  searchEnderecoFailure,
  finishIndicacaoSuccess,
  finishIndicacaoFailure,
} from './actions';
import { toggleLoading } from '../loading/actions';

import api from '../../../config/axios';
import convertBuscaEcResponse from '~/helpers/convertBuscaEcResponse';

export function* searchByCnpj({ payload }) {
  try {
    yield put(toggleLoading(true));

    const { data } = yield call(
      api.get,
      ENDPOINT_BUSCA_CNPJ.replace(':cnpj', payload),
    );

    const empresa = convertBuscaEcResponse(data.result);
    yield put(searchSuccess(empresa));
  } catch (e) {
    yield put(searchFailure());
  } finally {
    yield put(toggleLoading(false));
  }
}

export function* searchByEndereco({ payload }) {
  try {
    yield put(toggleLoading(true));

    const { telefone, ...params } = payload;
    const { data } = yield call(api.get, ENDPOINT_BUSCA_ENDERECO, {
      params,
    });

    const empresa = convertBuscaEcResponse(data.result);
    yield put(searchSuccess(empresa));
  } catch (e) {
    yield put(searchEnderecoFailure());
  } finally {
    yield put(toggleLoading(false));
  }
}

export function* finishIndicacao({ payload }) {
  try {
    yield put(toggleLoading(true));

    yield call(api.post, ENDPOINT_FINALIZA_INDICACAO, payload, {
      headers: { ORIGEM: 'portal' },
    });
    yield put(finishIndicacaoSuccess());
  } catch (e) {
    toast.error(
      'Estamos passando por instabilidades, tente novamente em alguns instantes',
    );
    yield put(finishIndicacaoFailure());
  } finally {
    yield put(toggleLoading(false));
  }
}

export default all([
  takeLatest(Types.SEARCH_CNPJ, searchByCnpj),
  takeLatest(Types.SEARCH_ENDERECO, searchByEndereco),
  takeEvery(Types.FINISH_INDICACAO_REQUEST, finishIndicacao),
]);
